import { render, staticRenderFns } from "./PublicDigitalAgreementSign.vue?vue&type=template&id=0b67b7a6&scoped=true"
import script from "./PublicDigitalAgreementSign.vue?vue&type=script&lang=js"
export * from "./PublicDigitalAgreementSign.vue?vue&type=script&lang=js"
import style0 from "./PublicDigitalAgreementSign.vue?vue&type=style&index=0&id=0b67b7a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b67b7a6",
  null
  
)

export default component.exports